export let shiftKey = false
addEventListener('keydown', event => event.keyCode === 16 && (shiftKey = true), true)
addEventListener('keyup', event => event.keyCode === 16 && (shiftKey = false), true)
